import isValidDomain from 'is-valid-domain';
import mapValues from 'lodash/mapValues';
import * as yup from 'yup';

const validationSchema = (t) =>
    yup.object({
        azureApplicationId: yup
            .string()
            .trim()
            .required(t('Form.fieldRequired')),
        azureApplicationSecret: yup
            .string()
            .trim()
            .required(t('Form.fieldRequired')),
        azureTenantId: yup
            .string()
            .trim()
            .required(t('Form.fieldRequired'))
            .uuid(t('Form.validUuid')),
        domains: yup
            .string()
            .trim()
            .required(t('Form.fieldRequired'))
            .test('validDomains', (domainsString, ctx) => {
                const domainsArray = domainsString.split(',');

                let valid = true;
                domainsArray.forEach((d) => {
                    if (!valid) return;

                    const domain = d.trim();
                    if (!domain) return;

                    if (!isValidDomain(domain)) {
                        valid = false;
                    }
                });

                if (!valid) {
                    return ctx.createError({
                        message: t(
                            'Clients.addModal.formFields.domains.invalidDomainsError'
                        )
                    });
                }

                return true;
            }),
        enableAzure: yup.boolean().required(),
        name: yup.string().trim().required(t('Form.fieldRequired')),
        useAsmAppCredentials: yup
            .bool()
            .required(t('Form.fieldRequired'))
            // Only accepts 'true' as a valid option.
            .oneOf([true], t('Form.fieldRequired'))
    });

// Using `.pick` to select the appropriate fields for each form.
export const noIntegrationFormSchema = (t) =>
    validationSchema(t).pick(['name', 'domains']);

export const manualIntegrationFormSchema = ({ t, tenantSyncConfigId }) => {
    if (tenantSyncConfigId) {
        return validationSchema(t).pick([
            'domains',
            'azureApplicationId',
            'azureApplicationSecret',
            'azureTenantId',
            'enableAzure'
        ]);
    }

    return validationSchema(t).pick([
        'name',
        'domains',
        'azureApplicationId',
        'azureApplicationSecret',
        'azureTenantId',
        'enableAzure'
    ]);
};

export const microsoftAutomatedIntegrationFormSchema = ({
    t,
    tenantSyncConfigId
}) => {
    if (tenantSyncConfigId) {
        return validationSchema(t).pick([
            'azureTenantId',
            'useAsmAppCredentials',
            'enableAzure'
        ]);
    }

    return validationSchema(t).pick([
        'name',
        'domains',
        'azureTenantId',
        'useAsmAppCredentials',
        'enableAzure'
    ]);
};

export const googleAutomatedIntegrationFormSchema = ({ t }) =>
    validationSchema(t).pick(['name', 'domains']);

export const inviteUserFormSchema = (t) =>
    yup.lazy((obj) =>
        yup.object(
            mapValues(obj, (value, key) => {
                if (key.includes('email')) {
                    return yup
                        .string()
                        .email(t('ConfigureSelfUser.error.email.invalid'))
                        .required(t('ConfigureSelfUser.error.email'));
                }
                return null;
            })
        )
    );
